<template>
  <div class="storeinformation">
    <div
      v-if="datas.styleType !== 3"
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <section
        v-if="datas.styleType === 1"
        class="goods_list_con goods_list_con1"
      >
        <!-- 视频图片 -->
        <div class="goods_img_con" v-if="vpnInfo.storeImg">
          <img draggable="false" :src="vpnInfo.storeImg" alt="" />
        </div>

        <!-- 内容 -->
        <div class="goods_info_con">
          <!-- 名称 -->
          <div
            class="name_con"
            :style="{
              color: datas.wordColor,
              'font-size': datas.wordSize + 'px',
              'font-weight': datas.isBold ? 'bold' : 'normal',
              'font-style': datas.isTilt ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLine ? 'underline' : 'none',
            }"
          >
            {{ vpnInfo.Name }}
          </div>
          <div>
            <div class="store_info_con" @click="phone(vpnInfo)">
              <div>
                <img
                  v-if="datas.phoneImageUrl"
                  draggable="false"
                  :src="datas.phoneImageUrl"
                  alt=""
                />
                <i v-else class="iconfont icon-dianhua" />
                <span
                  class="store_text_con"
                  :style="{
                    color: datas.wordColorSmallContent,
                    'font-size': datas.wordSizeSmallContent + 'px',
                    'font-weight': datas.isBoldSmallContent ? 'bold' : 'normal',
                    'font-style': datas.isTiltSmallContent
                      ? 'italic'
                      : 'normal',
                    'text-decoration': datas.isUnderLineSmallContent
                      ? 'underline'
                      : 'none',
                  }"
                  >{{ vpnInfo.Phone }}</span
                >
              </div>

              <div>
                <i class="iconfont icon-xiangyou" />
              </div>
            </div>
            <div class="store_info_con" @click="toAddress(vpnInfo)">
              <div>
                <img
                  v-if="datas.addressImageUrl"
                  draggable="false"
                  :src="datas.addressImageUrl"
                  alt=""
                />
                <i v-else class="iconfont icon-dingwei" />
                <span
                  class="store_text_con"
                  :style="{
                    color: datas.wordColorSmallContent,
                    'font-size': datas.wordSizeSmallContent + 'px',
                    'font-weight': datas.isBoldSmallContent ? 'bold' : 'normal',
                    'font-style': datas.isTiltSmallContent
                      ? 'italic'
                      : 'normal',
                    'text-decoration': datas.isUnderLineSmallContent
                      ? 'underline'
                      : 'none',
                  }"
                  >{{ vpnInfo.Address }}</span
                >
              </div>

              <div>
                <i class="iconfont icon-xiangyou" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="datas.styleType === 2"
        class="goods_list_con goods_list_con2"
      >
        <div class="f-bt c-m-b-15">
          <div
            class="ft-32"
            :style="{
              color: datas.wordColor,
              'font-size': datas.wordSize + 'px',
              'font-weight': datas.isBold ? 'bold' : 'normal',
              'font-style': datas.isTilt ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLine ? 'underline' : 'none',
            }"
          >
            {{ vpnInfo.Name }}
          </div>

          <div>
            <span
              :style="{
                color: datas.wordColorSmallTitle,
                'font-size': datas.wordSizeSmallTitle + 'px',
                'font-weight': datas.isBoldSmallTitle ? 'bold' : 'normal',
                'font-style': datas.isTiltSmallTitle ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineSmallTitle
                  ? 'underline'
                  : 'none',
              }"
              >营业时间:
            </span>
            <span
              :style="{
                color: datas.wordColorSmallContent,
                'font-size': datas.wordSizeSmallContent + 'px',
                'font-weight': datas.isBoldSmallContent ? 'bold' : 'normal',
                'font-style': datas.isTiltSmallContent ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineSmallContent
                  ? 'underline'
                  : 'none',
              }"
              >{{ vpnInfo.BusinessStartTime }}-{{
                vpnInfo.BusinessEndTime
              }}</span
            >
          </div>
        </div>
        <div class="f-bt c-m-b-15" @click="phone(vpnInfo)">
          <div>
            <div
              class="c-m-b-5"
              :style="{
                color: datas.wordColorSmallTitle,
                'font-size': datas.wordSizeSmallTitle + 'px',
                'font-weight': datas.isBoldSmallTitle ? 'bold' : 'normal',
                'font-style': datas.isTiltSmallTitle ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineSmallTitle
                  ? 'underline'
                  : 'none',
              }"
            >
              电话
            </div>
            <div
              :style="{
                color: datas.wordColorSmallContent,
                'font-size': datas.wordSizeSmallContent + 'px',
                'font-weight': datas.isBoldSmallContent ? 'bold' : 'normal',
                'font-style': datas.isTiltSmallContent ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineSmallContent
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ vpnInfo.Phone }}
            </div>
          </div>
          <div class="img_info_con">
            <img
              v-if="datas.phoneImageUrl"
              draggable="false"
              :src="datas.phoneImageUrl"
              alt=""
            />
            <i v-else class="iconfont icon-dianhua" />
          </div>
        </div>
        <div class="f-bt" @click="toAddress(vpnInfo)">
          <div>
            <div
              class="c-m-b-5"
              :style="{
                color: datas.wordColorSmallTitle,
                'font-size': datas.wordSizeSmallTitle + 'px',
                'font-weight': datas.isBoldSmallTitle ? 'bold' : 'normal',
                'font-style': datas.isTiltSmallTitle ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineSmallTitle
                  ? 'underline'
                  : 'none',
              }"
            >
              门店地址
            </div>
            <div
              :style="{
                color: datas.wordColorSmallContent,
                'font-size': datas.wordSizeSmallContent + 'px',
                'font-weight': datas.isBoldSmallContent ? 'bold' : 'normal',
                'font-style': datas.isTiltSmallContent ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineSmallContent
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ vpnInfo.Address }}
            </div>
          </div>
          <div class="img_info_con">
            <img
              v-if="datas.addressImageUrl"
              draggable="false"
              :src="datas.addressImageUrl"
              alt=""
            />
            <i v-else class="iconfont icon-dingwei" />
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <select-store-entrance></select-store-entrance>
    </div>
  </div>
</template>

<script>
import wxConfig from "@/utils/wxConfig.js";
import selectStoreEntrance from "@/newViews/homePage/comps/selectStoreEntrance.vue";

export default {
  name: "Storeinformation",
  props: {
    datas: Object,
  },
  components: {
    selectStoreEntrance,
  },
  watch: {
    "$store.state.vpnId"(val) {
      const vpnItem = this.allVpnList.find((v) => {
        return v.Id === val;
      });
      this.vpnInfo = vpnItem;
    },
  },
  data() {
    return {
      vpnInfo: {},
      allVpnList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    // sendVpnId(val) {
    //   this.vpnId = val;
    // },
    init() {
      const _this = this;
      if (localStorage.getItem("allStoreList")) {
        handleSetVpn();
      } else {
        window.addEventListener("setItem", () => {
          handleSetVpn();
          // $http(`wechath5/zh-cn/v1/vpn`).then((res) => {
          //   const vpnDatas = res.Items;
          //   this.allVpnList = vpnDatas;
          //   this.resetSetItem("websocketHistory", JSON.stringify(res.Items));
          //   let getVpnId = this.$store.state.vpnId;
          //   const vpnItem = vpnDatas.find((v) => {
          //     return v.Id === getVpnId;
          //   });
          //   if (getVpnId && vpnItem) {
          //     this.vpnInfo = vpnItem;
          //   } else {
          //     this.vpnInfo = vpnDatas[0];
          //   }
          // });
        });
      }

      function handleSetVpn() {
        _this.allVpnList = JSON.parse(localStorage.getItem("allStoreList"));
        let getVpnId = _this.$store.state.vpnId;
        const vpnItem = _this.allVpnList.find((v) => {
          return v.Id === getVpnId;
        });
        if (getVpnId && vpnItem) {
          _this.vpnInfo = vpnItem;
        } else {
          _this.vpnInfo = _this.allVpnList[0];
        }
      }
    },
    phone(item) {
      console.log(`22222<<<  item  >>>22222`);
      console.log(item);
      $pub.toTel(item.Phone);
    },
    toAddress(v) {
      if (v.Latitude && v.Longitude && v.Name && v.Address) {
        wxConfig.consultMap(this, v.Latitude, v.Longitude, v.Name, v.Address);
      } else {
        console.log(v.Latitude, v.Longitude, v.Name, v.Address);
        this.$toast("请在后台完善经纬度等信息");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.storeinformation {
  position: relative;
  .goods_list_con {
    // background: #fff;

    &.goods_list_con1 {
      display: flex;
      .goods_img_con {
        width: 220px;
        height: 180px;
        margin-right: 20px;
      }
      .goods_info_con {
        flex: 1;
      }
    }
    &.goods_list_con2 {
      // padding: 20px;
      // margin: 12px;
      // box-shadow: 0px 6px 20px 0px rgba(213, 213, 213, 0.5);
      // border-radius: 8px;
      .img_info_con {
        img {
          width: 40px;
          height: 40px;
          vertical-align: -4px;
        }
        .iconfont {
          font-size: 38px;
        }
      }
    }

    .goods_img_con {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goods_info_con {
      // padding: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name_con {
        margin-bottom: 15px;
      }

      .store_info_con {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
        .iconfont {
          font-size: 28px;
        }
        img {
          width: 30px;
          height: 30px;
          vertical-align: -4px;
        }
        .store_text_con {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
